import React, { Component } from "react";
import AnimateHeight from "react-animate-height";

import { fixExternalLinks } from "../../utils/helper";

class Accordion extends Component {
    constructor(props) {
        super(props);

        this._onPress = this._onPress.bind(this);
    }

    _onPress() {
        this.props.onPress(this.props.id);
    }

    render() {
        const { id, section, current } = this.props;

        const open = current === id;

        let height = 0;
        if (open) height = "auto";

        return (
            <div
                id={id}
                key={id}
                className={"border-b border-orange mb-12 xl:mb-16"}
            >
                <div
                    className={"cursor-pointer pb-12"}
                    aria-expanded={height !== 0}
                    aria-controls={id}
                    onClick={this._onPress}
                >
                    <p className="font-judge font-bold text-17 xl:text-30 text-orange uppercase">
                        {section.title}
                    </p>
                </div>
                <AnimateHeight id={id} duration={300} height={height}>
                    <div className={"flex pb-12 xl:pb-20"}>
                        <div
                            className="article-body ml-32 leading-tight font-bold text-17 xl:text-23 text-orange"
                            dangerouslySetInnerHTML={{
                                __html: fixExternalLinks(section.body),
                            }}
                        />
                    </div>
                </AnimateHeight>
            </div>
        );
    }
}

export default Accordion;
